import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { verifyPaystackPayment } from "../redux/slices/paymentSlice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Text,
  Spinner,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Code,
  VStack,
  Heading,
} from "@chakra-ui/react";
import { setloadTost } from "../redux/slices/toastSlice";

const PaystackCallback = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const reference = queryParams.get("reference");

  const [verificationSuccess, setVerificationSuccess] = useState(false);
  const [verifiedDetails, setVerifiedDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const handlePaymentConfirmation = async () => {
    try {
      const response = await dispatch(
        verifyPaystackPayment(reference)
      ).unwrap();
      if (response?.isSuccess) {
        setVerificationSuccess(true);
        setVerifiedDetails(response.data); // update if structure differs
        dispatch(
          setloadTost({
            title: "Confirmation",
            description: "Verified Successfully",
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top",
          })
        );
        // Delay before navigating back homepage
        setTimeout(() => navigate("/"), 4000);
      } else {
        dispatch(
          setloadTost({
            title: "Error",
            description:
              response?.response?.data?.error?.description ||
              "Verification failed",
            status: "warning",
            duration: 5000,
            isClosable: true,
            position: "top",
          })
        );
        setTimeout(() => navigate("/"), 4000);
      }
    } catch (error) {
      console.error(error);
      dispatch(
        setloadTost({
          title: "Error",
          description: "An error occurred during confirmation.",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top",
        })
      );
      navigate("/");
    } finally {
      setLoading(false);
    }
  };

  useEffect((response) => {
    handlePaymentConfirmation();
  });

  return (
    <Box p={6} maxW="600px" mx="auto">
      <Heading size="lg" mb={4}>
        Payment Verification
      </Heading>

      {loading ? (
        <VStack spacing={4}>
          <Spinner size="xl" />
          <Text>Verifying your payment, please wait...</Text>
        </VStack>
      ) : verificationSuccess ? (
        <Alert status="success" variant="left-accent" mt={4}>
          <AlertIcon />
          <Box>
            <AlertTitle>Payment Verified Successfully!</AlertTitle>
            <AlertDescription>
              <Text mt={2}>
                Reference ID: <Code colorScheme="green">{reference}</Code>
              </Text>
              <Text mt={2}>
                Status:{" "}
                <Code colorScheme="blue">
                  {verifiedDetails?.status || "Completed"}
                </Code>
              </Text>
            </AlertDescription>
          </Box>
        </Alert>
      ) : (
        <Alert status="error" variant="left-accent" mt={4}>
          <AlertIcon />
          <Box>
            <AlertTitle>Verification Failed</AlertTitle>
            <AlertDescription>
              Unable to verify your payment. Please contact support.
            </AlertDescription>
          </Box>
        </Alert>
      )}
    </Box>
  );
};

export default PaystackCallback;
